import Immutable from 'immutable';
import { filterDataByFilterOptions } from '../';

function filterArticles(articles, filters) {
	let filteredArticles = Immutable.List(articles).toJS();
	filteredArticles = filterDataByFilterOptions(filteredArticles, filters);
	return filteredArticles;
}

export { filterArticles };
